export default {
  REACT_APP_ENCRYPTION_KEY: "aB$9@x1T#7!zWq*5%JvK3rN8^sL0yP!Q",
  API_ENDPOINT:
    "https://akashpatel.co.in/spectus-hrms-backend-laravel/public/api" ||
    process.env.API_ENDPOINT,
  apiKey: "AIzaSyDhG6xkTHndmsh3UZECKJnA_SXhL2LQba8",
  authDomain: "spectus-hrms.firebaseapp.com",
  projectId: "spectus-hrms",
  storageBucket: "spectus-hrms.appspot.com",
  messagingSenderId: "135727565830",
  appId: "1:135727565830:web:32f7d2393f3d9dd9b54787",
  measurementId: "G-29CSBYMB8V",
  emailJsServiceId1: "service_350ck4z",
  emailJsAccountId1: "_F1LGRJLLbs465dZA",
  forgotPasswordTemplateId: "template_abdesu7",
  welcomeTemplateId: "template_5k44bar",
  emailJsServiceId2: "service_l2jbq3p",
  emailJsAccountId2: "5AYgnG0o831-VUyEV",
  leaveStatusTemplateId: "template_4g2keut",
  applyLeaveTempalateId: "template_v3kt0yi",
  baseName: "/",
  backend_api_endpoint: "https://hrmsapis.spectusinfotech.com",
  basic_email_params: {
    from_email: "hr@spectusinfotech.com",
  },
  subject_mode: "",
};
